import React from "react";
import tz from "./tz.png";

class notice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="page_type_h5">
        <article id="wxMiniDrainage">
          <img src={tz} style={{ width: "100%" }} />
        </article>
      </div>
    );
  }
}

export default notice;



// WEBPACK FOOTER //
// ./src/staticPage/wxMini/index.js